<template>
  <el-row :gutter="8" class="hidden-md-and-down">
    <el-col v-if="rowData.organisation" :span="this.isManager() ? 14 : 23">
      <contacts-popover :row-data="rowData" />
    </el-col>

    <el-col v-if="isManager('maintenance') || isViewOnly()" :span="rowData.organisation ? 8 : 23">
    <el-button icon="fa fa-trash-alt"
    @click="deleteEntry()" size="small" type="danger" circle :disabled="isViewOnly()"></el-button>
    </el-col>
  </el-row>
  </template>

  <script>

  import PostMixins from '@/mixins/PostMixins'
  import ContactsPopover from '@/components/atoms/ContactsPopover'

  export default {
    mixins: [PostMixins],
    components: {
      ContactsPopover
    },

    props: {
      rowData: {
        type: Object,
        required: true
      },
      tableRef: {
        type: String,
        default: 'tickettable'
      }
    },
    methods: {
      deleteEntry () {
        let msg = this.rowData.organisation
          ? this.rowData.category + ' for ' + this.rowData.organisation.name
          : this.rowData.category

        this.deleteItem(this, this.rowData.id, '/tickets', msg, this.onDelete)
      },
      onDelete (response) {
        this.$events.emit(this.tableRef + '-refresh-table')
        // Distinct delete signal so a drawer DetailLayer can close itself on
        // delete only (not on save, which shares the refresh channel). XOL-230.
        this.$events.emit(this.tableRef + '-row-deleted')
        this.$emit('update-stats')
      }
    }
  }
  </script>

  <style>
  .item {
    margin-top: 10px;
    margin-right: 40px;
  }
  </style>
